export const allSettingTypes = [
    {
        "id": 0,
        "systemName": "system",
        "displayName" : "سیستم"
    },
    {
        "id": 1,
        "systemName": "application",
        "displayName" : "برنامه"
    },
    {
        "id": 2,
        "systemName": "applicationUser",
        "displayName" : "کاربر"
    }
];

export const byId = (id)=>{
    return allSettingTypes.find(st=>st.id===id) || {}
}

export const titleById = (id)=>{
    return byId(id).displayName || "";
}